export default {
  name: process.env.REACT_APP_NAME,
  isDev: process.env.NODE_ENV !== 'production',
  isProduction: process.env.NODE_ENV === 'production',

  apiURL: process.env.REACT_APP_API_URL,
  appUrl: process.env.REACT_APP_BASE_APP_URL,

  timeFormat: 'hh:mm A',
  dateFormat: 'ddd DD MMMM YYYY',
  dateTimeFormat: 'ddd DD MMMM YYYY hh:mm A',
};
